import { isError } from "../../utils/Functions";
import { ApiError } from "../generated/api";

export const isApiClientError = (error: unknown): error is ApiError => {
  return isError(error) && error.name === "ApiError";
};